export const specialities = [
	{ label: "Cats", value: "FELINE" },
	{ label: "Dogs", value: "CANINE" },
	{ label: "Horses", value: "EQUINE" },
	{ label: "Cows", value: "BOVINE" },
	{ label: "Goats", value: "CAPRINE" },
	{ label: "Sheep", value: "OVINE" },
	{ label: "Pigs", value: "PORCINE" },
	{ label: "Poultry", value: "POULTRY" },
	{ label: "Llamas", value: "LLAMAS" },
	{ label: "Alpacas", value: "ALPACAS" },
	{ label: "Birds", value: "AVIAN" },
	{ label: "Fish", value: "AQUATIC" },
	{ label: "Reptiles", value: "REPTILIAN" },
	{ label: "Bunnies", value: "LAGOMORPH" },
	{ label: "Hamsters", value: "HAMSTERS" },
	{ label: "Rats", value: "RODENT" },
	{ label: "Guinea pigs", value: "GUINEA_PIGS" },
	{ label: "Hedgehogs", value: "HEDGEHOGS" },
	{ label: "Amphibian", value: "AMPHIBIAN" },
	{ label: "Primate", value: "PRIMATE" },
	{ label: "Marsupial", value: "MARSUPIAL" },
	{ label: "Ferrets", value: "MUSTELIDAE" },
	{ label: "Others", value: "OTHERS" },
];

export const petTypes = [
	{ label: "Cat", value: "FELINE" },
	{ label: "Dog", value: "CANINE" },
	{ label: "Horse", value: "EQUINE" },
	{ label: "Cow", value: "BOVINE" },
	{ label: "Goat", value: "CAPRINE" },
	{ label: "Sheep", value: "OVINE" },
	{ label: "Pig", value: "PORCINE" },
	{ label: "Poultry", value: "POULTRY" },
	{ label: "Llama", value: "LLAMAS" },
	{ label: "Alpaca", value: "ALPACAS" },
	{ label: "Bird", value: "AVIAN" },
	{ label: "Fish", value: "AQUATIC" },
	{ label: "Reptile", value: "REPTILIAN" },
	{ label: "Bunny", value: "LAGOMORPH" },
	{ label: "Hamster", value: "HAMSTERS" },
	{ label: "Guinea pig", value: "GUINEA_PIGS" },
	{ label: "Rat", value: "RODENT" },
	{ label: "Ferrets", value: "MUSTELIDAE" },
	{ label: "Hedgehog", value: "HEDGEHOGS" },
];

export const rhapsodyPetTypes = [
	{ label: "Cat", value: "FELINE" },
	{ label: "Dog", value: "CANINE" },
	{ label: "Horse", value: "EQUINE" },
	{ label: "Cow", value: "BOVINE" },
	{ label: "Goat", value: "CAPRINE" },
	{ label: "Sheep", value: "OVINE" },
	{ label: "Pig", value: "PORCINE" },
	{ label: "Poultry", value: "POULTRY" },
	{ label: "Llamas", value: "LLAMAS" },
	{ label: "Alpaca", value: "ALPACAS" },
	{ label: "Bird", value: "AVIAN" },
	{ label: "Fish", value: "AQUATIC" },
	{ label: "Reptiles", value: "REPTILIAN" },
	{ label: "Bunnies", value: "LAGOMORPH" },
	{ label: "Hamsters", value: "HAMSTERS" },
	{ label: "Rats", value: "RODENT" },
	{ label: "Guinea pig", value: "GUINEA_PIGS" },
	{ label: "Hedgehogs", value: "HEDGEHOGS" },
	{ label: "Amphibian", value: "AMPHIBIAN" },
	{ label: "Primate", value: "PRIMATE" },
	{ label: "Marsupial", value: "MARSUPIAL" },
	{ label: "Ferret", value: "MUSTELIDAE" },
	{ label: "Other", value: "OTHERS" },
];
